import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeSentry } from './lib/sentry.ts'

// Initialize error monitoring for production
initializeSentry();

createRoot(document.getElementById("root")!).render(<App />);
